var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ic_Logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_01",
    "data-name": "Path 01",
    d: "M0,0H100V100H0Z",
    fill: "rgba(255,255,255,0.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_02",
    "data-name": "Path 02",
    d: "M47.1,90.25C23.474,90.25,4.25,70.419,4.25,46.043A44.978,44.978,0,0,1,14.923,16.85a43.719,43.719,0,0,1,6.417-6.135,42.988,42.988,0,0,1,4.286-2.933A3.742,3.742,0,1,1,29.471,14.2a35.463,35.463,0,0,0-3.536,2.42A36.218,36.218,0,0,0,20.618,21.7a37.491,37.491,0,0,0-8.883,24.339c0,20.25,15.866,36.724,35.368,36.724S82.472,66.293,82.472,46.043A37.492,37.492,0,0,0,73.589,21.7a36.22,36.22,0,0,0-5.316-5.083,35.465,35.465,0,0,0-3.537-2.42,3.742,3.742,0,1,1,3.845-6.419,42.985,42.985,0,0,1,4.286,2.933,43.718,43.718,0,0,1,6.417,6.135A44.978,44.978,0,0,1,89.957,46.043C89.957,70.419,70.733,90.25,47.1,90.25Z",
    transform: "translate(2.896 2.604)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_02-2",
    "data-name": "Path 02",
    d: "M27.044,54.6A3.794,3.794,0,0,1,23.25,50.8V7.044a3.794,3.794,0,1,1,7.588,0V50.8A3.794,3.794,0,0,1,27.044,54.6Z",
    transform: "translate(22.956 1.708)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/Ic_Logout.5a948a9b07077dfc7492ae7403cf1cce.svg";
export { ForwardRef as ReactComponent };